import styled from "styled-components";

import { ProfileNotificationsStyledProps as Props } from "./ProfileNotifications.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const ProfileNotificationsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-gray-s0-l97);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .ProfileNotifications {
    &__header {
      grid-area: header;
    }

    &__main {
      grid-area: main;
      margin-bottom: 3.2rem;
      padding-top: 8.8rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem 1fr;
        grid-template-rows: min-content max-content;
        grid-template-areas: "profile-navigation content";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__profile-navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
        margin-left: 4rem;
      }
    }

    &__content {
      grid-area: content;
      flex: 1;
      padding: 0 8rem;

      @media (max-width: ${desktop}px) {
        padding: 0 4rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        padding-left: 0;
        padding-top: 0;
      }

      &__header {
        padding-bottom: 2.4rem;
        border-bottom: 0.1rem solid var(--palette-gray-s0-l25);
      }

      &__title {
        margin-bottom: 2.4rem;
        font-size: 2.4rem;
        font-weight: 600;
      }
    }

    &__container {
      background-color: var(--palette-white);
      padding: 2.4rem;
      border-radius: 1.6rem;
    }

    &__config {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__config-name {
      font-size: 1.6rem;
      padding-right: 1.6rem;
      font-weight: 700;
    }

    &__switch-error-message {
      margin-top: 0.4rem;
      font-size: 1.2rem;
      color: var(--palette-red-s60-l60);
    }

    &__footer {
      grid-area: footer;
    }
  }
`;

export default ProfileNotificationsStyled;
